"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var defaultTheme_1 = __importDefault(require("./defaultTheme"));
var NdsThemeProviderBaseHoc_1 = __importDefault(require("./NdsThemeProviderBaseHoc"));
var NdsThemeProviderDefault = NdsThemeProviderBaseHoc_1.default(defaultTheme_1.default);
exports.NdsThemeProviderRootComp = NdsThemeProviderDefault;
exports.default = NdsThemeProviderDefault;
//# sourceMappingURL=NdsThemeProvider.js.map